// core
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

// services
import { QuoteService } from '@campfire-nx/api';
import { PartnerBrandService } from '@campfire-nx/api';

@Injectable({
  providedIn: 'root'
})
export class EstimateResolver implements Resolve<any> {

  constructor(
    private quoteService: QuoteService,
    private partnerBrandService: PartnerBrandService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
    var params!: string;
    let urlChunk: Array<string> = state.url.split('?');

    if (urlChunk.length > 1) {
       params = urlChunk[1];
    }

    return this.quoteService.estimate(route.params.uuid, params)
      .then((response: any) => {
        this.partnerBrandService.setHandoverData(response);
        return response;
      });
  }
}
